<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">諸掛費用登録</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search()" class="btn-search" v-permit.SHARP_LFS_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>

        <v-btn
          :disabled="selected.length !== 1"
          @click="detail"
          v-permit.SHARP_LFS_DETAIL
          >明細</v-btn
        >

        <v-btn
          @click="downloadChargeBySupplier('', 'archive')"
          v-permit.SHARP_LFS_LOCAL_DETAIL
          >請求用諸掛明細実績帳票</v-btn
        >
        <v-btn
          @click="advanceChargeDownload"
          v-permit.SHARP_LFS_LOCAL_ADVANCE_REPORT
          >立替金帳票出力</v-btn
        >

        <v-btn @click="domesticList" v-permit.SHARP_LOCAL_DO_FEE_LIST_DOWNLOAD
          >検索結果出力</v-btn
        >
        <v-btn
          @click="downloadChargeBySupplier('', 'business')"
          v-permit.SHARP_LFS_LOCAL_DETAIL
          >請求用諸掛明細速報</v-btn
        >
        <v-btn @click="doPartConfirmed" v-permit.SHARP_LFS_LOCAL_DETAIL
          >DO一部確定分</v-btn
        >
        <v-btn
          :disabled="
            selected.length === 0 ||
              selected.filter(
                (item) =>
                  item.otherLocalChargeCount > 0 ||
                  item.addtionalPaymentChargeCount > 0 ||
                  item.localDeliveryUnLoginCount > 0 ||
                  item.localCustomsCount > 0
              ).length > 0 ||
              selected.filter(
                (item) => item.chargeApprovalStatus === '諸掛承認済'
              ).length > 0
          "
          @click="batchConfirm"
          v-permit.SHARP_BATCH_LFD_CONFIRM
          >諸掛一括承認</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field label="D/O NO" v-model="query.doNo" />
            </v-flex>
            <v-flex
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs3
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buHeadquartersId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.blNo')"
                v-model="query.blNo"
              />
            </v-flex>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_CUSTOMS_CLEARANCE'
                )
              "
              xs12
            >
              <remote-autocomplete
                label="サプライヤー"
                url="companies/kvt?type=SUPPLIER"
                v-model="query.forwarderId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                url="ports/kv"
                v-model="query.loadingPortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.etd')"
                    :max="query.etdTo"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.eta')"
                    :max="query.etaTo"
                    v-model="query.etaFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etaFrom"
                    label="~"
                    v-model="query.etaTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.forecastTo"
                    label="最終納入日"
                    v-model="query.forecastFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.forecastFrom"
                    label="~"
                    v-model="query.forecastTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_CUSTOMS_CLEARANCE'
                )
              "
              xs12
            >
              <v-select
                :items="showStatus"
                :multiple="true"
                clearable
                item-text="text"
                item-value="value"
                label="承認ステータス"
                v-model="query.confirmStatus"
              ></v-select>
            </v-flex>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.some(
                  (r) => r.roleCode === 'ROLE_CUSTOMS_CLEARANCE'
                )
              "
              xs12
            >
              <v-select
                :items="showStatusForSupplier"
                :multiple="true"
                clearable
                item-text="text"
                item-value="value"
                label="承認ステータス"
                v-model="query.chargeStatus"
              ></v-select>
            </v-flex>
            <v-flex md1 sm6 xs12>
              <v-text-field label="CONTAINER NO" v-model="query.containerNo" />
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-checkbox
                label="諸掛一括承認対象"
                v-model="query.otherLocalPaymentChargeCountZero"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 30, 50]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.blNo }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.buCode }}</td>
          <td>{{ props.item.chargeApprovalStatus }}</td>
          <td>
            {{ props.item.loadingPortCode + ' ' + props.item.loadingPortName }}
          </td>
          <td>
            {{
              props.item.dischargePortCode + ' ' + props.item.dischargePortName
            }}
          </td>
          <td>{{ props.item.etd }}</td>
          <td>{{ props.item.eta }}</td>
          <td>
            {{
              props.item.sumOtherLocalCharge | currency({ fractionCount: 0 })
            }}
          </td>
          <td>{{ props.item.lastConfirmDate }}</td>
          <td>{{ props.item.lastForecastDate }}</td>
          <td>
            {{
              props.item.chargeApprovalStatus == '諸掛承認済'
                ? props.item.lastAgreeDate
                : null
            }}
          </td>
          <!-- <td>
            {{ props.item.otherLocalChargeCount }},
            {{ props.item.addtionalPaymentChargeCount }},
            {{ props.item.localDeliveryUnLoginCount }},
            {{ props.item.localCustomsCount }}
          </td> -->
        </template>
      </v-data-table>
    </v-card>
    <advance-charge-dialog ref="advanceChargeDialog" />
    <charge-by-supplier-dialog ref="chargeBySupplierDialog" />
  </v-container>
</template>

<script>
import AdvanceChargeDialog from './AdvanceChargeDialog'
import ChargeBySupplierDialog from './ChargeBySupplierDialog'

export default {
  components: {
    AdvanceChargeDialog,
    ChargeBySupplierDialog,
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  methods: {
    batchConfirm() {
      this.$http
        .put('/shipping-advices/batch-confirm', this.selected.map((a) => a.id))
        .then((res) => {
          this.$message('', 'success!')
          this.load()
        })
    },
    doPartConfirmed() {
      this.$download(`reports/part-do-confirm`)
    },
    domesticList() {
      let url = `/reports/domestic-list?doNo=${this.query.doNo}&partnerId=${
        this.query.partnerId
      }&buId=${this.query.buHeadquartersId}&blNo=${
        this.query.blNo
      }&supplierId=${this.query.forwarderId}&loadingPortCode=${
        this.query.loadingPortCode
      }&dischargePortCode=${this.query.dischargePortCode}&etaFrom=${
        this.query.etaFrom
      }&etaTo=${this.query.etaTo}&etdFrom=${this.query.etdFrom}&etdTo=${
        this.query.etdTo
      }&forecastFrom=${this.query.forecastFrom}&forecastTo=${
        this.query.forecastTo
      }&containerNo=${this.query.containerNo}`
      url =
        url +
        '&confirmStatus=' +
        (this.query.confirmStatus ? this.query.confirmStatus.join(',') : '')
      url =
        url +
        '&chargeStatus=' +
        (this.query.chargeStatus ? this.query.chargeStatus.join(',') : '')
      this.$download(url)
    },
    advanceChargeDownload() {
      this.$refs.advanceChargeDialog.popup().then((p) => {
        this.$download(
          `/reports/advance-charges?dateFrom=${p.from}&dateTo=${p.to}`
        )
      })
    },
    load() {
      this.query.moduleCode = 'F1100'
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/shipping-advices?view=B1100', {
          params: {
            ...this.query,
            chargeStatus:
              this.query.chargeStatus && this.query.chargeStatus.join(','),
            confirmStatus:
              this.query.confirmStatus && this.query.confirmStatus.join(','),
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    detail() {
      this.$router.push({
        path: '/B1101',
        query: { id: this.selected[0].id },
      })
    },
    downloadChargeBySupplier(root, category) {
      this.$refs.chargeBySupplierDialog.popup().then((p) => {
        console.log(p)
        this.$download(
          `${root}/reports/local-approve/V2/${category}?yearMonth=${
            p.yearMonth
          }`
        )
      })
    },
  },
  mounted() {
    this.$loadParams()
  },
  data() {
    return {
      showStatus: [
        { text: '諸掛承認済', value: '諸掛承認済' },
        { text: '諸掛未申請', value: '諸掛未申請' },
        { text: '諸掛一部承認済', value: '諸掛一部承認済' },
        { text: '諸掛承認待ち', value: '諸掛承認待ち' },
      ],
      showStatusForSupplier: [
        { text: '諸掛承認済', value: '1' },
        { text: '諸掛未申請', value: '-1' },
        { text: '諸掛承認待ち', value: '0' },
      ],
      query: {
        moduleCode: 'F1100',
      },
      results: [],
      loading: false,
      selected: [],
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        { text: 'D/O NO', value: 'deliveryOrderNo', sortable: false },
        { text: 'B/L NO', value: 'BLNo', sortable: false },
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: '事業本部コード', value: 'headquarter', sortable: false },
        { text: '承認ステータス', value: 'approvalStauts', sortable: false },
        { text: '積出港', value: 'shipingPort', sortable: false },
        { text: '陸揚港', value: 'landingPort', sortable: false },
        { text: 'ETD', value: 'etd', sortable: false },
        { text: 'ETA', value: 'eta', sortable: false },
        { text: 'その他諸掛', value: 'otherVariousTimes', sortable: false },
        { text: '最後DO確定日', value: 'lastConfirmDate', sortable: false },
        { text: '最終納入日', value: 'lastForecastDate', sortable: false },
        { text: '諸掛承認日', value: 'lastAgreeDate', sortable: false },
      ],
      form: [
        { label: 'D/O NO', field: 'deliveryOrderNo', type: 'text' },
        { label: 'B/L NO', field: 'BLNo', type: 'text' },
        { label: 'サプライヤー', field: 'supplier', type: 'autocomplete' },
        { label: '積出港', field: 'shipingPort', type: 'autocomplete' },
        { label: '陸揚港', field: 'landingPort', type: 'autocomplete' },
        { label: 'ETD', field: 'etd', type: 'text' },
        { label: 'ETA', field: 'eta', type: 'text' },
      ],
    }
  },
}
</script>
